<template>
  <v-app>
    <v-main class="d-flex align-center justify-content-center">
      <v-container class="mx-auto pa-0 my-16">
        <v-row no-gutters class="fill-height">
          <v-col width="1024" cols="12">

            <v-row class="fill-height" no-gutters>
              <v-row class="d-flex justify-content-center">
                <!-- Logo -->
                <router-link :to="{
                  path: '/',
                }" title="TicketShop" tag="a"><v-img max-height="64" max-width="85"
                    src="/images/Logo-black.svg"></v-img>
                </router-link>
              </v-row>
              <v-col cols="12" class="my-8">
                <v-card no-gutters flat class="d-flex mx-auto align-content-space-around flex-column " width="360">
                  <v-card-title class="font-weight-bold text-break" tag="h4">
                    Restablecer constraseña
                  </v-card-title>
                  <v-card-subtitle style="
												font-weight: 500;
											"> <v-icon left>mdi-email-outline</v-icon>Ingrese
                    el correo electronico de su cuenta.
                  </v-card-subtitle>

                  <!-- //Formulario  -->
                  <v-col>
                    <v-form autocomplete="on" class="mb-0 align-content-space-between" @submit.prevent="resetPassword">
                      <v-card-subtitle class="px-0 mx-0">Correo Electronico</v-card-subtitle>
                      <v-text-field placeholder="ejemplo@correo.com" solo required v-model="email"
                        :rules="emailRules"></v-text-field>


                      <v-btn class="text-button" color="primary" height="44px" block rounded type="submit">Enviar
                        Código
                      </v-btn>
                      <router-link :to="{ path: '/login' }" title="Login" tag="a">
                        <v-btn outlined class="text-button mt-4" color="primary" height="44px" block rounded
                          type="submit">Iniciar
                          Sesión
                        </v-btn>
                      </router-link>
                    </v-form>
                  </v-col>

                </v-card>
              </v-col>

            </v-row>

          </v-col>

        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      //vm.$store.dispatch('fetchAccessToken');
      if (vm.$store.state.user.accessToken != null) {
        next("/");
      }
    });
  },
  created() {
    document.title = "Olvide mi contraseña - TicketShop";
  },
  data() {
    return {
      email: null,
      emailRules: [
        (v) => /.+@.+/.test(v) || "Direccion de correo electronico incorrecta",
      ],
    };
  },
  methods: {
    resetPassword() {
      this.$store.dispatch("resetPassword", { email: this.email }).then(() => {
        // this.email = null;
        // this.$router.push("/");
      });
    },
  },
};
</script>
<style scoped></style>
